import { Component, input } from '@angular/core';
import { Booking } from '../../../../core/models/entities/booking';
import {
  Payment,
  PaymentStatus,
} from '../../../../core/models/entities/payment';

@Component({
  selector: 'app-customer-payments-table',
  template: `
    <app-table
      [data]="payments()"
      [trackByFn]="trackByPaymentId"
      [clickableRows]="false"
      emptyStateTitle="Aucun paiement"
      emptyStateMessage="Aucun paiement n'est disponible pour cette réservation."
      emptyStateIcon="far fa-credit-card"
    >
      <!-- Method Column -->
      <app-table-column
        field="method"
        header="Méthode"
        [alwaysVisibleOnMobile]="true"
        [showLabelOnMobile]="false"
      >
        <ng-template let-payment>
          <div class="font-medium">
            {{ payment.method_humanized }}
          </div>
        </ng-template>
      </app-table-column>

      <!-- Date Column -->
      <app-table-column field="date" header="Date">
        <ng-template let-payment>
          {{ payment.updated_at | date: 'dd.MM.yyyy HH:mm' }}
        </ng-template>
      </app-table-column>

      <!-- Amount Column -->
      <app-table-column
        field="amount"
        [alwaysVisibleOnMobile]="true"
        [showLabelOnMobile]="false"
        header="Montant"
        headerClasses="justify-end"
      >
        <ng-template let-payment>
          <div class="sm:text-right">
            {{ payment.value | chf }}
          </div>
        </ng-template>
      </app-table-column>

      <!-- Status Column -->
      <app-table-column field="status" header="Statut">
        <ng-template let-payment>
          <app-badge
            [variant]="getPaymentStatusBadgeVariant(payment.status)"
            size="sm"
          >
            {{ getPaymentStatusLabel(payment.status) }}
          </app-badge>
        </ng-template>
      </app-table-column>
    </app-table>
  `,
  standalone: false,
})
export class CustomerPaymentsTableComponent {
  booking = input.required<Booking>();
  payments = input<Payment[]>([]);

  PaymentStatus = PaymentStatus;

  trackByPaymentId = (payment: Payment): number => payment.id;

  getPaymentStatusLabel(status: PaymentStatus): string {
    switch (status) {
      case PaymentStatus.Fulfill:
        return 'Payé';
      case PaymentStatus.Pending:
        return 'En attente';
      case PaymentStatus.Authorized:
        return 'Pré-autorisé';
      case PaymentStatus.Failed:
        return 'Échoué';
      default:
        return 'En attente';
    }
  }

  getPaymentStatusBadgeVariant(
    status: PaymentStatus,
  ): 'success' | 'secondary' | 'danger' | 'outlined' {
    switch (status) {
      case PaymentStatus.Fulfill:
        return 'success';
      case PaymentStatus.Pending:
        return 'outlined';
      case PaymentStatus.Authorized:
        return 'outlined';
      case PaymentStatus.Failed:
        return 'danger';
      default:
        return 'secondary';
    }
  }
}
